import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import { LanguageProvider } from './i18n/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import './cinematic.css';

// Marketing pages
import CinematicHome from './pages/CinematicHome';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import ServiceAreasPage from './pages/ServiceAreasPage';
import FAQPage from './pages/FAQPage';
import HowBailWorksPage from './pages/HowBailWorksPage';

// Intake
import IntakePage from './pages/IntakePage';

// Dashboard
import DashboardApp from './pages/dashboard/DashboardApp';
import SSOCallback from './pages/SSOCallback';

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <Router>
            <div className="App">
              <Routes>
                {/* Marketing */}
                <Route path="/" element={<CinematicHome />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/service-areas" element={<ServiceAreasPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/how-bail-works" element={<HowBailWorksPage />} />

                {/* Intake */}
                <Route path="/intake" element={<IntakePage />} />
                <Route path="/intake/:step" element={<IntakePage />} />

                {/* Cross-Brand SSO */}
                <Route path="/sso/amigos-callback" element={<SSOCallback />} />

                {/* Dashboard */}
                <Route path="/dashboard/*" element={<DashboardApp />} />
                <Route path="/webmaster/*" element={<DashboardApp />} />

                {/* Fallback */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
            <Toaster
              position="top-right"
              toastOptions={{
                style: { background: '#0f172a', color: '#F8FAFC', border: '1px solid rgba(235,110,31,0.25)' }
              }}
            />
          </Router>
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
